// extracted by mini-css-extract-plugin
module.exports = {"card":"Station_card__1zMoY"};